const BASE = "https://static.prod-images.emergentagent.com/jobs/e98db5da-ea5f-4177-9298-90daa2274d49/images/";

export const GAME_COVERS = {
  penalty: `${BASE}446e4947cfb011552cc60d298e552cb706e69f07bb0d5a4ba82145c6270dd533.jpeg`,
  flip: `${BASE}8f32d7b54a0b0554ea1147eefa99cd48052081fa39d96d76907d9f12793d26cc.jpeg`,
  hoop: `${BASE}fe52ba1b71ef18b694aef26a182a8f3882fd7b383badcd721f2aa24de6a1ca69.jpeg`,
  treasure: `${BASE}40d57cdc380dad359146b50df564720e34db081b7f4549b5c01ba85e2865e7a7.jpeg`,
  dice: `${BASE}feebbef009f1ad1bbfe464fdaad97ab0ef36cab55a8516cf164748049842b745.jpeg`,
  wheel: `${BASE}1d6b71627cc2b371c8ef28e9b4d2c4b8dc630c05d3122e81428752789664987c.jpeg`,
};

export const LOBBY_ART = {
  hero: `${BASE}d0a8a944fff8da8aad9a8c2469de22276adc6fc25a08043a781ded779156905f.jpeg`,
  arcade: `${BASE}f925507dfbc4b21d16fa7614acfe482343c9a73088c438aca4a7e743b6f00433.jpeg`,
  charts: `${BASE}74cfdbd1d5c91d0ce98910e36120e01b04cd2da32761aa19878f76aa058250e1.jpeg`,
  history: `${BASE}1b2d209ba055e76402778f1d4a8898787c0278b271ee306bcc7773ab2566e33a.jpeg`,
};
